<template>
  <div class="web-page-container">
    <StarTabs :tabs="['配置', '统计分析', '最近任务']" v-model="tabActiveIndex" />

    <div class="web-page-mid">
      <div class="web-page-inner">
        <Config v-if="tabActiveIndex === 0" />
        <Statistics v-if="tabActiveIndex === 1" />
        <RecentTask v-if="tabActiveIndex === 2" />
      </div>
    </div>
  </div>
</template>

<script>
import Statistics from '../Statistics'
import RecentTask from '../RecentTask'
import Config from '../Config'
import StarTabs from '@/components/StarTabs'
export default {
  components: {Config, Statistics, RecentTask, StarTabs },
  data() {
    return {
      spiderClassId: '',
      tabActiveIndex: 0
    }
  },
  created() {
    let { spiderClassId } = this.$route.query
    if (spiderClassId) {
      this.spiderClassId = Number(spiderClassId)
    }
  }
}
</script>

<style lang="less" scoped>
.web-page-container {
  width: 100%;

  .web-page-mid {
    padding: 16px;

    .web-page-inner {
      width: 100%;
    }
  }
}
</style>
